import { render } from "./humidity.svg.vue?vue&type=template&id=1f603bd4"
import script from "./humidity.svg.vue?vue&type=script&lang=js"
export * from "./humidity.svg.vue?vue&type=script&lang=js"
script.render = render

export default script